<!-- src/views/consentimientos/SignaturePad.vue -->
<template>
  <div class="signature-wrapper">
    <div class="signature-label">Firma del paciente</div>
    <div class="canvas-container" :class="{ 'has-signature': tieneFirma }">
      <canvas
        ref="canvasRef"
        :width="ancho"
        :height="alto"
        class="signature-canvas"
        @mousedown="iniciarTrazo"
        @mousemove="dibujar"
        @mouseup="terminarTrazo"
        @mouseleave="terminarTrazo"
        @touchstart.prevent="iniciarTrazo"
        @touchmove.prevent="dibujar"
        @touchend="terminarTrazo"
      />
      <div v-if="!tieneFirma" class="placeholder-text">
        Firme aquí con el cursor o dedo
      </div>
    </div>
    <div class="signature-actions">
      <button class="btn-limpiar" :disabled="!tieneFirma" @click="limpiar">
        ✕ Limpiar
      </button>
      <div class="firma-status" v-if="tieneFirma">✓ Firma capturada</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignaturePad',

  props: {
    ancho: { type: Number, default: 500 },
    alto:  { type: Number, default: 160 }
  },

  emits: ['update:firma'],

  data() {
    return {
      tieneFirma: false,
      dibujando: false,
      ctx: null
    }
  },

  mounted() {
    this.ctx = this.$refs.canvasRef.getContext('2d')
    this.ctx.strokeStyle = '#1a1a2e'
    this.ctx.lineWidth = 2
    this.ctx.lineCap = 'round'
    this.ctx.lineJoin = 'round'
  },

  methods: {
    obtenerPunto(e) {
      const rect = this.$refs.canvasRef.getBoundingClientRect()
      const scaleX = this.$refs.canvasRef.width / rect.width
      const scaleY = this.$refs.canvasRef.height / rect.height
      const fuente = e.touches ? e.touches[0] : e
      return {
        x: (fuente.clientX - rect.left) * scaleX,
        y: (fuente.clientY - rect.top)  * scaleY
      }
    },

    iniciarTrazo(e) {
      this.dibujando = true
      const punto = this.obtenerPunto(e)
      this.ctx.beginPath()
      this.ctx.moveTo(punto.x, punto.y)
    },

    dibujar(e) {
      if (!this.dibujando) return
      const punto = this.obtenerPunto(e)
      this.ctx.lineTo(punto.x, punto.y)
      this.ctx.stroke()
    },

    terminarTrazo() {
      if (!this.dibujando) return
      this.dibujando = false
      this.tieneFirma = true
      const base64 = this.$refs.canvasRef
        .toDataURL('image/png')
        .split(',')[1]
      this.$emit('update:firma', base64)
    },

    limpiar() {
      this.ctx.clearRect(0, 0, this.ancho, this.alto)
      this.tieneFirma = false
      this.$emit('update:firma', null)
    }
  }
}
</script>

<style scoped>
.signature-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.signature-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.canvas-container {
  position: relative;
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  transition: border-color 0.2s, background 0.2s;
  cursor: crosshair;
}

.canvas-container.has-signature {
  border-color: #6366f1;
  border-style: solid;
  background: #fff;
}

.signature-canvas {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
}

.placeholder-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #9ca3af;
  pointer-events: none;
}

.signature-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-limpiar {
  padding: 6px 14px;
  font-size: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-limpiar:hover:not(:disabled) {
  border-color: #ef4444;
  color: #ef4444;
  background: #fef2f2;
}

.btn-limpiar:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.firma-status {
  font-size: 12px;
  color: #10b981;
  font-weight: 500;
}
</style>